import { render, staticRenderFns } from "./tabs-accordions.vue?vue&type=template&id=39d73125"
import script from "./tabs-accordions.vue?vue&type=script&lang=js"
export * from "./tabs-accordions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports